/** Build ordered category chip labels for filters (always includes "All"). */
export function buildCategoryChips(categoriesFromApi, stores) {
  const fromCat = (categoriesFromApi || [])
    .map((c) =>
      typeof c === "string" ? c : c?.name || c?.title || c?.label || ""
    )
    .filter(Boolean);
  const fromStores = [
    ...new Set((stores || []).map((s) => s.category).filter(Boolean)),
  ];
  const merged = [...new Set([...fromStores, ...fromCat])].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );
  return ["All", ...merged];
}
